import VideoPlayer from 'components/common/VideoPlayer'

export default ({ Image, currentVideoId, currentVideoLink, handleMarkAsWatched, playNextVideo, wasAlreadyWatched, goTo, selectedQuality, onQualitySelected }) => {
  return (
    currentVideoId
      ? (
        <VideoPlayer
          posterLink={Image}
          videoLink={currentVideoLink}
          handleMarkAsWatched={handleMarkAsWatched}
          nextVideo={playNextVideo}
          wasAlreadyWatched={wasAlreadyWatched}
          selectedQuality={selectedQuality}
          onQualitySelected={onQualitySelected}
          goTo={goTo}
        />
        )
      : null
  )
}
